<template>
  <base-stat-item :metric="metric" label="Enquiry Via Social">
    <template v-slot:icon>
      <social-enquiry-icon></social-enquiry-icon>
    </template>
  </base-stat-item>
</template>
<script>
import BaseStatItem from './BaseStatItem.vue';
import SocialEnquiryIcon from '../Icons/SocialEnquiryIcon.vue';

export default {
  props: {
    metric: [String, Number],
  },
  components: {
    BaseStatItem,
    SocialEnquiryIcon,
  },
};
</script>
